import { useEffect, useRef, useState } from 'react';
import { Queue } from '../../../models/Queue';
import { fetchQueues } from '../../../services/fetchQueues';

interface UseTransferQueuesResult {
  queues: Queue[];
  isLoading: boolean;
  hasError: boolean;
}

export const useTransferQueues = (open: boolean, originalQueueId?: string): UseTransferQueuesResult => {
  const [queues, setQueues] = useState<Queue[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const fetchedForQueueId = useRef<string | undefined>(undefined);
  const isTheSameQueueId = fetchedForQueueId.current === originalQueueId;

  useEffect(() => {
    if (!open || !originalQueueId) return;
    if (isTheSameQueueId && queues.length > 0) return;

    const loadQueues = async () => {
      setIsLoading(true);
      setHasError(false);

      try {
        const response = await fetchQueues(originalQueueId);
        fetchedForQueueId.current = originalQueueId;
        setQueues(response.data);
      } catch (error) {
        console.error('Error fetching queues:', error);
        setHasError(true);
      } finally {
        setIsLoading(false);
      }
    };

    loadQueues();
  }, [open, originalQueueId, isTheSameQueueId, queues.length]);

  return { queues, isLoading, hasError };
};
